'use client';

import { Children, cloneElement, FC, ReactNode, isValidElement } from 'react';
import Button from '@egalite/ui/Buttons';
import NavbarLogo from './NavbarLogo';
import NavbarMenuButton from './NavbarMenuButton';
import NavbarMenuContent from './NavbarMenuContent';
import NavbarMenuWrapper from './NavbarMenuWrapper';
import NavbarMenuAnchor from './NavbarMenuAnchor';

type Props = {
	children?: ReactNode;
};

const NavbarBase: FC<Props> = ({ children }) => {
	// Clonar children para adicionar prop mobile=true para versão mobile
	const mobileChildren = Children.map(children, (child) => {
		if (isValidElement(child)) {
			return cloneElement(child, { ...child.props, mobile: true });
		}
		return child;
	});

	return (
		<header className="h-[66px] lg:h-[86px] bg-white relative z-50">
			<nav aria-label="Navegação principal" className="w-11/12 max-w-[1280px] mx-auto h-full flex items-center justify-between">
				<NavbarLogo />

				{/* Centered Navigation */}
				{/* Entre md (1024px) e lg (1360px) o espaço é justo para os itens do menu:
				    o espaçamento menor é o que evita o logo e os botões colidirem com os links. */}
				<div className="hidden md:flex flex-1 justify-center items-center h-full gap-4 lg:gap-10">
					{children}
				</div>

				{/* Right Side Buttons */}
				<div className="flex items-center gap-6">
					<div className="hidden md:flex items-center gap-4 lg:gap-6">
						<a href="/login" className="text-[#0F1DD7] font-bold text-[15px] hover:opacity-80 transition-opacity">
							Entrar
						</a>
						<a 
							href="/candidato/cadastrar"
							className="flex items-center justify-center rounded-full px-8 lg:px-10 h-[52px] font-bold bg-[#0F1DD7] text-white hover:bg-[#000EB4] transition-colors shadow-sm text-[16px]"
						>
							Cadastre-se
						</a>
					</div>

					<NavbarMenuWrapper>
						<NavbarMenuButton />

						<NavbarMenuAnchor />

						<NavbarMenuContent>{mobileChildren}</NavbarMenuContent>
					</NavbarMenuWrapper>
				</div>
			</nav>
		</header>
	);
};

export default NavbarBase;
